import { render, staticRenderFns } from "./openClassDetail.vue?vue&type=template&id=fef96b86&scoped=true"
import script from "./openClassDetail.vue?vue&type=script&lang=js"
export * from "./openClassDetail.vue?vue&type=script&lang=js"
import style0 from "./openClassDetail.vue?vue&type=style&index=0&id=fef96b86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef96b86",
  null
  
)

export default component.exports